
const deactivateQuestion = (toDeactivate, selector, thenFocus =true) =>
{
    const CSS_DEACTIVATED = 'form__row--deactivated';
    const $questions = $(selector);

    $questions.each((idx, element) =>
    {
        const $self = $(element);

        if (toDeactivate)
        {
            $self.addClass(CSS_DEACTIVATED);
            $self.find('input, select').attr('disabled', 'disabled');
        }
        else
        {
            $self.removeClass(CSS_DEACTIVATED);
            $self.find('input, select').removeAttr('disabled');
        }
    });

    if (thenFocus && !toDeactivate)
    {
        setTimeout(() =>
        {
            $questions.eq(0).find('input, select').get(0).focus();
        }, 0);
    }
};


$(() =>
{
    $('[data-enable-part-on-select]').each((idx, elm) =>
    {
        const $self = $(elm);
        const selector = $self.data('enable-part-on-select');

        const radioGroup = $self.attr('name');
        const radiosGroup = $(`input[type="radio"][name="${radioGroup}"]`);

        radiosGroup.on('click', () =>
        {
            deactivateQuestion(!$self.is(':checked'), selector);
        });

        // Initial state:
        deactivateQuestion(!$self.is(':checked'), selector, false);
    })

    $('[data-enable-part-on-checked]').each((idx, elm) =>
    {
        const $self = $(elm);
        const selector = $self.data('enable-part-on-checked');

        $self.on('click', () =>
        {
            deactivateQuestion(!$self.is(':checked'), selector);
        });

        // Initial state:
        deactivateQuestion(!$self.is(':checked'), selector, false);
    })
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/form/form-disable-part.js